import {createDivIn, createHeaderIn, createSpanIn, createTextareaIn, setElementInnerHTML} from '../../ui_utils/DomUtils'
import {UIStoreGiftBaseSelectionController} from './UIStoreGiftBaseSelectionController'
import {clientI18n} from '../../ClientI18n'

export class UIStoreGiftDetailsSelectionController extends UIStoreGiftBaseSelectionController {
    private messageInput: HTMLTextAreaElement

    constructor(parentDiv: HTMLDivElement, sidebarContainer: HTMLDivElement, checkoutAction: () => void, hideGiftOverlayAction: () => void) {
        super(parentDiv, sidebarContainer, hideGiftOverlayAction, checkoutAction)
    }

    get giftMessage(): string {
        return this.messageInput.value
    }

    resetForm() {
        this.messageInput.value = ''
    }

    protected override createSidebarButton(): void {
        super.createSidebarButton()
        setElementInnerHTML(this.selectionTitle, {key: 'strings:storePage.sections.giftOverlay.detailsSelection.title'})
    }

    protected override createPageContent(): void {
        super.createPageContent()
        createHeaderIn(this.pageTitle, {key: 'strings:storePage.sections.giftOverlay.detailsSelection.title'}, '', '', 'H2')

        this.createMessageInput()
        this.mainCTAButton = this.createCheckoutButton()
    }

    private createMessageInput() {
        const maximumNumberOfCharacters = 150
        const messageContainer = createDivIn(this.pageContainer, 'store-gift-overlay-details-input-container')
        const titleAndCounterContainer = createDivIn(messageContainer, 'store-gift-overlay-details-message-title-and-counter-container')
        createHeaderIn(titleAndCounterContainer, {key: 'strings:storePage.sections.giftOverlay.detailsSelection.message'}, '', '', 'H2')
        const characterCounter = createSpanIn(titleAndCounterContainer, 'input-counter', {key: 'strings:colonistCommon.utils.#buffer', options: {value: `0/${maximumNumberOfCharacters}`}})
        this.messageInput = createTextareaIn(messageContainer, 'store-gift-overlay-message-input')
        this.messageInput.placeholder = clientI18n.t('strings:storePage.sections.giftOverlay.detailsSelection.messagePlaceholder')
        this.messageInput.maxLength = maximumNumberOfCharacters
        this.messageInput.addEventListener('input', () => characterCounter.textContent = `${this.messageInput.value.length}/${maximumNumberOfCharacters}`)
    }
}
